import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorjsComponent } from '../../base/editorjs/editorjs.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { UploadService } from '../../upload.service';
import { EditionArticleService } from '../../edition-article.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EditionArticleFormData } from '../../base/interfaces';
import { DatePipe } from '@angular/common';
import { EditionArticle } from '../../shared/intefaces/edition-article';
import { finalize, take } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import * as moment from 'moment';
import slugify from 'slugify';

@Component({
  selector: 'app-edition-article-edit',
  templateUrl: './edition-article-edit.component.html',
  styleUrls: ['./edition-article-edit.component.scss'],
})
export class EditionArticleEditComponent implements OnInit {
  editionArticle: EditionArticle;
  image = '';

  @ViewChild('preview') previewEditor: EditorjsComponent;
  @ViewChild('content') contentEditor: EditorjsComponent;

  editionArticleForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
    author: new FormControl(''),
    index: new FormControl(''),
    date: new FormControl('', [Validators.required]),
  });

  private sub: any;

  constructor(
    private notifier: NotifierService,
    private uploadService: UploadService,
    private editionArticleService: EditionArticleService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params.id === undefined) {
        this.notifier.notify('error', 'Matéria não encontrado');

        this.router.navigate(['/editions']);
      }

      const id = params.id;

      this.editionArticleService
        .getEditionArticle(id)
        .pipe(take(1))
        .subscribe(
          (response) => {
            this.editionArticle = response.data();
            const datepipe: DatePipe = new DatePipe('en-US');

            this.editionArticleForm.patchValue({
              title: this.editionArticle.title,
              slug: this.editionArticle.slug,
              date: datepipe.transform(
                this.editionArticle.date.toDate(),
                'yyyy-MM-dd'
              ),
              author: this.editionArticle.author,
              index: this.editionArticle.index,
            });

            this.image = this.editionArticle.image;
          },
          (error) => {
            this.notifier.notify('error', error.message);
          }
        );
    });

    this.editionArticleForm.get('title').valueChanges.subscribe((value) => {
      this.editionArticleForm.get('slug').setValue(
        slugify(value, {
          lower: true,
          strict: true,
        })
      );
    });
  }

  public deleteImage(): void {
    this.notifier.notify('success', 'Imagem removida com sucesso.');

    this.image = '';
  }

  public uploadImage(file: File): void {
    const extension = file.name.split('.').pop();
    const filePath = `${uuidv4()}.${extension}`;

    this.uploadService
      .uploadFirebase(file, filePath)
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.image = filePath;

          this.notifier.notify('success', 'Imagem enviada com sucesso');
        })
      )
      .subscribe();
  }

  public submit() {
    this.contentEditor.save().then((contentData) => {
      this.previewEditor.save().then((previewData) => {
        const editionArticleData: any = {
          ...this.editionArticleForm.value,
          index: Number(this.editionArticleForm.value.index),
          date: moment(this.editionArticleForm.value.date).toDate(),
          image: this.image,
          preview: JSON.stringify(previewData),
          description: JSON.stringify(contentData),
        };

        this.editionArticleService
          .update(this.editionArticle.id, editionArticleData)
          .then(() => {
            this.notifier.notify('success', 'Matéria criada com sucesso');

            this.router.navigate([
              '/edition_articles',
              this.editionArticle.edition,
            ]);
          })
          .catch(() => {
            this.notifier.notify('error', 'Erro na hora de criar os dados');
          });
      });
    });
  }
}
